import { z } from 'zod';
const dateTimeSchema = z.string().datetime({ offset: true });
export const timelineItemSchema = z.object({
    id: z.string().regex(/^[a-zA-Z0-9_-]+$/),
    title: z.string().max(200),
    startDate: dateTimeSchema,
    endDate: dateTimeSchema.optional(),
}).superRefine((value, ctx) => {
    if (value.endDate && new Date(value.startDate) > new Date(value.endDate)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'startDate must be earlier than or equal to endDate',
            path: ['startDate'],
        });
    }
});
export const timelineSectionSchema = z.object({
    id: z.string().regex(/^[a-zA-Z0-9_-]+$/),
    label: z.string().min(1).max(200),
    hidden: z.boolean().optional(),
    items: z.array(timelineItemSchema),
});
export const timelinePageSchema = z.object({
    id: z.string().regex(/^[a-zA-Z0-9_-]+$/),
    label: z.string().min(1).max(200),
    sections: z.array(timelineSectionSchema).min(1),
});
export const timelineDataSchema = z.object({
    pages: z.array(timelinePageSchema).min(1).max(1),
});
